import { useAppStore } from '../store/useAppStore.js';
import { SignInCard } from './SignInCard.js';

export function LoginOnlyView() {
  const setView = useAppStore((s) => s.setView);

  function goToRegister() {
    setView('login');
    if (window.location.pathname !== '/') window.history.pushState({}, '', '/');
  }

  return (
    <div className="mx-auto w-full max-w-md flex flex-col gap-6 animate-fade-up">
      <img
        src="/asl-go-logo.avif"
        alt="ASL Go"
        className="w-full max-w-[16rem] mx-auto select-none dark:invert"
      />
      <SignInCard />
      <p className="text-center text-[0.85rem] text-ink-600 dark:text-[#b6b2c4]">
        New here?{' '}
        <button type="button" onClick={goToRegister} className="underline text-ink-900 dark:text-brand-bright">
          Create an account
        </button>
      </p>
    </div>
  );
}
